/**
 * 대표 섬네일 presigned URL 의 만료/실패를 처리한다. `<img onError>` 가 부모에게 알리면
 * dataset source 를 다시 조회해 새 URL 을 받는다. 이 모듈은 최소 간격마다 1회만 트리거하는
 * 디바운서를 만든다. 그래서 한 화면의 카드가 동시에 만료되어도 refresh 가 반복 실행되지 않는다.
 *
 * presigned URL 은 요청할 때마다 새로 서명된다(계약 §3.4.3). 그래서 만료는 1회 재조회로 해결된다.
 * GCS 가 계속 실패해도 이 간격이 refresh 루프를 막는다.
 */

const REFRESH_MIN_INTERVAL_MS = 60_000;

export function createThumbnailRefreshDebouncer(refresh: () => void): () => void {
  let lastRefreshAtMs = 0;
  return () => {
    const nowMs = Date.now();
    if (nowMs - lastRefreshAtMs < REFRESH_MIN_INTERVAL_MS) {
      return;
    }
    lastRefreshAtMs = nowMs;
    refresh();
  };
}
